import React from 'react';

// Styles
import styles from './style.module.scss';

interface CheckboxProps {
  id: string;
  checked: boolean;
  readOnly?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string | React.ReactNode;
  className?: string;
}


const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked,
  readOnly = false,
  onChange,
  label,
  className,
}) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <input
        id={id}
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={onChange ? (e) => onChange(e.target.checked) : undefined}
        readOnly={readOnly}
      />

      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  )
}

export default Checkbox;
